import clsx from 'clsx';

export type IconLabelProps = {
  icon?: React.ReactNode;
  label: React.ReactNode;
  selected?: boolean;
  isBold?: boolean;
  isMaxMdShowIconBorder?: boolean;
  className?: string;
  subfix?: React.ReactNode;
};

export function IconLabel(props: IconLabelProps) {
  const { icon, label, selected, isBold, isMaxMdShowIconBorder, className, subfix } = props;

  return (
    <span
      className={clsx(
        'inline-flex items-center truncate',
        clsx(
          'gap-1 text-base font-500 hover:text-primary',
          selected ? 'text-primary' : 'text-secondary',
        ),
        clsx(
          'max-os:text-lg max-os:hover:text-primary',
          selected ? 'max-os:text-primary' : 'max-os:text-color-sub',
          isMaxMdShowIconBorder ? 'max-os:gap-3' : 'max-os:gap-2',
          isBold ? 'max-os:font-600' : 'max-os:font-500',
        ),
        className,
      )}
    >
      {!!icon && (
        <span
          className={clsx(
            'inline-flex items-center justify-center',
            isMaxMdShowIconBorder &&
              clsx(
                'max-os:h-[24px] max-os:w-[24px] max-os:rounded-md max-os:border max-os:border-color-split max-os:p-[5px] max-os:shadow-xs',
                selected && 'max-os:border-primary max-os:bg-primary max-os:text-inverse',
              ),
          )}
        >
          {icon}
        </span>
      )}
      <span className="truncate">{label}</span>
      {subfix}
    </span>
  );
}
